enum SidebarLeftMode {
	NONE = "NONE",
	PAGES = "PAGES",
	ATTACHMENTS = "ATTACHMENTS",
	OUTLINES = "OUTLINES",
	SIGNATURES = "SIGNATURES",
	SEARCH = "SEARCH"
}

export default SidebarLeftMode;